export function useRemoveDuplicateQueryParams(url: string) {
    const [baseUrl, queryString] = url.split('?')

    if (!queryString) {
        return url
    }
    const paramsArray = queryString.split('&')

    // Unique params without categoryUrlParam:
    const uniqueParamsMap = new Map()
    for (let i = paramsArray.length - 1; i >= 0; i--) {
        const [key, value] = paramsArray[i].split('=')
        if (!uniqueParamsMap.has(key)) {
            uniqueParamsMap.set(key, value)
        }
    }
    uniqueParamsMap.delete('categoryUrlParam')
    const uniqueParamsArray = [...uniqueParamsMap].reverse().map(([key, value]) => `${key}=${value}`)
    const uniqueParams = uniqueParamsArray.join('&')

    // Unique categoryUrlParam:
    let categoryParams = ''
    let categoryArray = paramsArray.filter((param) => param.startsWith('categoryUrlParam'))
    if (categoryArray?.length) {
        const categorySet = new Set(categoryArray)
        categoryArray = Array.from(categorySet)
        categoryParams = categoryArray.join('&')
    }

    // Final Url with params
    let cleanUrl = `${baseUrl}?${uniqueParams}`
    if (categoryParams.length) {
        cleanUrl = `${cleanUrl}&${categoryParams}`
    }

    return cleanUrl
}
